import React, { useState, useEffect } from 'react';
import { Modal, Button, Checkbox, Message, Icon } from 'semantic-ui-react';
import { I18n, Translate } from 'react-redux-i18n';
import { ICampaignOrganizer } from '../../../models/CampaignOrganizer';

interface Props {
  isOpen: boolean;
  item: ICampaignOrganizer | null;
  isDeleting: boolean;
  error: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}

const DeleteCampaignOrganizerModal: React.FC<Props> = ({
  isOpen,
  item,
  isDeleting,
  error,
  onConfirm,
  onCancel,
}) => {
  const [accepted, setAccepted] = useState(false);

  useEffect(() => {
    if (isOpen) setAccepted(false);
  }, [isOpen, item?.id]);

  if (!item) return null;

  return (
    <Modal
      open={isOpen}
      onClose={isDeleting ? undefined : onCancel}
      closeOnDimmerClick={!isDeleting}
      closeOnEscape={!isDeleting}
      size='small'
    >
      <Modal.Header>
        <Icon name='warning sign' color='red' />
        <Translate value='campaignOrganizers.page.delete.title' />
      </Modal.Header>
      <Modal.Content>
        <p>
          <strong>{item.name}</strong>
        </p>
        <Message negative>
          <Translate value='campaignOrganizers.page.delete.warning' />
        </Message>
        <Checkbox
          label={I18n.t('campaignOrganizers.page.delete.confirmCheckbox')}
          checked={accepted}
          onChange={(_, data) => setAccepted(!!data.checked)}
          disabled={isDeleting}
        />
        {error && (
          <Message negative style={{ marginTop: 12 }}>
            <p>{error}</p>
          </Message>
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onCancel} disabled={isDeleting}>
          <Translate value='campaignOrganizers.page.delete.cancel' />
        </Button>
        <Button
          negative
          loading={isDeleting}
          disabled={!accepted || isDeleting}
          onClick={onConfirm}
        >
          <Icon name='trash' />
          <Translate value='campaignOrganizers.page.delete.confirm' />
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default DeleteCampaignOrganizerModal;
